import * as React from 'react';

function SvgBlockedFilled(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.79 12c0-5.085 4.125-9.21 9.21-9.21 5.086 0 9.212 4.125 9.212 9.21 0 5.086-4.126 9.212-9.212 9.212-5.085 0-9.21-4.126-9.21-9.211zm4.74-6.53a.75.75 0 00-1.06 1.06l11 11a.75.75 0 001.06-1.06l-11-11z", clipRule: "evenodd" })));
}

export default SvgBlockedFilled;
